module.exports = __webpack_public_path__ + "static/media/jacob.3a5e63ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/crew/jacob.jpg
// module id = 605
// module chunks = 0